/** Server-verified identity fields replace cached values after session restore. */
export function mergeVerifiedUser<T extends Record<string, any>>(cached: T, verified: Record<string, any>): T {
  return { ...cached, ...verified } as T;
}
